import React, { useEffect, useRef, useState } from "react";
import { createPortal } from "react-dom";
import { Link } from "react-router-dom";
import logo from "./assets/logofinal-flat.png";
import { PublicFooter } from "./PublicSiteChrome";
import "./AuthenticatedFooterDock.css";

export default function AuthenticatedFooterDock() {
  const [expanded, setExpanded] = useState(false);
  const footerRef = useRef(null);

  useEffect(() => {
    const footer = footerRef.current;
    if (!footer) return undefined;

    const syncNavbarStop = () => {
      const height = Math.ceil(footer.getBoundingClientRect().height);
      document.documentElement.style.setProperty(
        "--wv-app-footer-nav-stop",
        `${Math.max(58, height)}px`
      );
    };

    syncNavbarStop();
    const observer = new ResizeObserver(syncNavbarStop);
    observer.observe(footer);
    window.addEventListener("resize", syncNavbarStop);

    return () => {
      observer.disconnect();
      window.removeEventListener("resize", syncNavbarStop);
      document.documentElement.style.removeProperty("--wv-app-footer-nav-stop");
    };
  }, []);

  useEffect(() => {
    if (!expanded) return undefined;
    const closeOnEscape = (event) => {
      if (event.key === "Escape") setExpanded(false);
    };
    window.addEventListener("keydown", closeOnEscape);
    return () => window.removeEventListener("keydown", closeOnEscape);
  }, [expanded]);

  const handleFooterNavigate = () => {
    setExpanded(false);
  };

  if (typeof document === "undefined") return null;

  return createPortal(
    <footer
      ref={footerRef}
      className={`wv-appFooter${expanded ? " is-expanded" : ""}`}
      aria-label="Weavevo footer"
      data-weavevo-auth-footer="true"
    >
      <div className="wv-appFooterPanel" aria-hidden={!expanded}>
        <PublicFooter
          className="wv-appFooterSharedHomeFooter"
          footerId="wv-authenticated-shared-footer"
          homeHref="/public"
          onNavigate={handleFooterNavigate}
        />
      </div>

      <div className="wv-appFooterDockBar">
        <Link className="wv-appFooterDockBrand" to="/public" aria-label="Weavevo workspace">
          <img src={logo} alt="" aria-hidden="true" />
          <span>weavevo</span>
        </Link>

        <nav className="wv-appFooterDockNav" aria-label="Footer shortcuts">
          {["Application", "Use Cases", "Resources", "Company", "Contact / Support"].map((label) => (
            <button
              key={label}
              type="button"
              className="wv-appFooterDockNavToggle"
              aria-expanded={expanded}
              onClick={() => setExpanded((current) => !current)}
            >
              {label}
            </button>
          ))}
        </nav>

        <button
          type="button"
          className="wv-appFooterToggle"
          aria-expanded={expanded}
          aria-label={expanded ? "Collapse footer" : "Expand footer"}
          onClick={() => setExpanded((current) => !current)}
        >
          <span>{expanded ? "Close" : "More"}</span>
          <i className={`bi ${expanded ? "bi-chevron-down" : "bi-chevron-up"}`} aria-hidden="true" />
        </button>
      </div>
    </footer>,
    document.body
  );
}
